
import { API_MAP } from "../apiConfig";
import axiosInstance from "../../../../Services/Global-Services/UnauthorizedTokenHandler";

export const callProjectAPI = async (intent, data) => {
  const api = API_MAP[intent];

  if (!api) throw new Error(`Unknown intent: ${intent}`);

  const response = await axiosInstance({
    url: api.endpoint,
    method: api.method,
    data
  });

  const result = response.data;

  // Check if the API response indicates success
  if (result.StatusCode !== 200) {
    throw new Error(result.Message || "An error occurred while processing your request.");
  }

  return result;
};

